<template>
  <div class="mobileindex">
    <div class="to-login-box" v-if="!login">
      <div class="title">快速克隆，高效创作</div>
      <div class="sub-title">
        手机在线数字人克隆平台，快速完成形象及声音定制， <br />
        AI文案创作大模型，一键生成口播视频
      </div>
      <div class="loginBtn" @click="drawer3 = true">登录</div>
    </div>
    <div class="mobiletop" v-if="login">
      <img src="@/assets/mobile/AI_Logo-ff4e72d9.png" alt="" class="logo" />
      <img
        :src="$store.userInfo.avatar"
        alt=""
        class="avatar"
        @click="drawer = true"
      />
      <el-drawer
        size="80%"
        :visible.sync="drawer"
        :with-header="false"
        :show-close="false"
      >
        <div class="usermsg">
          <div>
            <img :src="$store.userInfo.avatar" alt="" />
            <p>
              <span>{{ $store.userInfo.nickname }}</span>
              <span>当前可用分钟数:{{ $store.userInfo.ai_drop }}</span>
            </p>
          </div>
          <div>
            <p>
              <img src="@/assets/mobile/id.png" alt="" />{{
                $store.userInfo.id
              }}
            </p>
          </div>
        </div>
        <div
          class="member"
          :style="'background-image:url(' + bg + ')'"
          @click="jumprouter('/member', 1)"
        >
          <div>
            <p><img src="@/assets/mobile/vip.png" />购买{{website.web_title}}会员</p>
            <p>让创作灵感，触手可得</p>
          </div>
          <div>
            <p>立即购买></p>
          </div>
        </div>
        <div class="card">
          <ul>
            <li
              v-for="(item, index) in list[0]"
              :key="index"
              @click="jumprouter(item.router, item.type)"
            >
              <img :src="item.icon" alt="" />
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
        <div class="card">
          <ul>
            <li
              v-for="(item, index) in list[1]"
              :key="index"
              @click="jumprouter(item.router, item.type)"
            >
              <img :src="item.icon" alt="" />
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
        <el-button @click="loginout()">退出登录</el-button>
      </el-drawer>
    </div>
    <div class="mobilecenter">
      <ul v-show="login">
        <li
          v-for="(item, index) in fun"
          :key="index"
          @click="jumprouter(item.router, item.type)"
        >
          <img :src="item.icon" alt="" />
          <p>{{ item.name }}</p>
        </li>
      </ul>
      <div class="swiper">
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          style="text-align: center"
        >
          <swiper-slide :class="swiperIndex == -1 ? 'swiperOn' : ''"
            ><span data-id="0" :data-index="-1">全部</span></swiper-slide
          >
          <swiper-slide
            :class="swiperIndex == index ? 'swiperOn' : ''"
            v-for="(item, index) in swiperdata"
            :key="index"
            ><span :data-index="index" :data-id="item.id">{{
              item.title
            }}</span></swiper-slide
          >
        </swiper>
      </div>
    </div>
    <div class="mobilefooter">
      <ul v-if="createlist.length>0">
        <li
          v-for="(item, index) in createlist"
          :key="index"
          @click="jumppage(item.type, item.id)"
        >
          <div class="left">
            <div>
              <p><img :src="item.image" alt="" /></p>
              <span>{{ item.title }}</span>
            </div>
            <div>{{ item.sub_title }}</div>
          </div>
          <div class="right"><i class="el-icon-arrow-right"></i></div>
        </li>
      </ul>
      <div v-else  class="no-data-box">
          <div class="no-data">
            <div>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAM9SURBVHgB7ZddSBRRFMfPjCvszjyoaQlmOCu4pGglGJoPai4EoulGCkqIQj1YLwW91mP00EOvggVlL0IGQiUV+JEU9hhYkkVYacW6WpaMX7s70z13d7bd2cn9GGfHwB8MM3P33Ln/mf2fc+9lQANXe48gAXSBibAAd4cGej+p2y1awRLDjPEcJ/C8DcxAFNdAXF11kcvymMGutgtHmjvOy1PT72WzmHo7I6OGpvaeOrU+Vt0gWeSufXuzobS4CMyitMQBPEf/3Vr1b6xGvMtMsQr1NVXAMky3uj3Cw2gHCWTBWXssIsjv98PGxgYYSXp6Oj0UqioOw8MnYwLa4tFA7zhoCf6XHURRBEmSwEi8Xi9kZGSE7hVbrIiraItxpV1tiSg7bG5uGi4WIblGRYejZYuQYFcgI4XmhvqITig4Vahth7ZATeHVIiRYZllqB3tBfqgDflmfzwepAscKHw9tgZoYhmmBKMGyXFdZcSjiAevr65Bqom1RCQxAt3JPBSt2cNb8rQ7oqVR+XQW0II6tUFbswFOmYgsqWMsO+KapSDY1KDY8b9S2YINBUXYwuu5uxVa2YLXsgFbAycIs1MkXbgsL2oG3WWmRXvAs0YA1kmzeGOWMs9mA46yQDItLP2PG/F4RwWoNPB8tgYfbs9TCkFXRLGkTIAlO1FfDmdamhPpcv9kH7z7MQpIs49QsnGw4rhTpuCHLTxh4MJyQYPyyKPZsZxsUCvshEYLjZdK1hL3gAFk/OBJ6QKDyDBMRy5CTnRlXH0/QCmUlRREVKR7cnh/0zEKSFAYHnP/mjrvPl/nvNFcSFRtO0oJ5nqOruqejL+Lu82z0JVQmaD01SQtGzhEvTs98hKHHIzFj+/rvA5uWBh2nG0EPFtCBXcgnCdQKt+8NUn+eanQSP2dFxGCi9fUPwtxXN1zs6aTlSQ+6BCO4HM0lIm4R0Zev3oCDDjvk7MkKicWqgCKvXblEX1AvugUj6Es8RiZewRtSfhYWAxNQXl4udLa7tnVDuy2CFZxkh4CHkehKOjPYFWw0u4KNxoJz++jzSVqOdjKzn+cCWyWybBsbmZisg/+A6qPldxi8IHu6Wtj5/CIb0dd/AHXns06xLbPKAAAAAElFTkSuQmCC"
              />
            </div>
            <div  class="no-data-title">
              <span>没找到你想要的模板？ 要不试试 换个关键词<br/>或者</span><span  class="clear-title" @click="jumprouter('/feedback',1)">反馈给我们</span>
            </div>
          </div>
      </div>
    </div>
    <copyright></copyright>
    <el-drawer
      size="40%"
      direction="btt"
      :visible.sync="drawer1"
      :with-header="false"
      :show-close="false"
    >
      <div class="accountbox">
        <div class="title">
          <p>账号绑定</p>
          <p @click="drawer1 = false"><i class="el-icon-arrow-down"></i></p>
        </div>
        <ul>
          <li>
            <img
              src="data:image/png;base64,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"
              alt=""
            />
            <p class="center">手机号</p>
            <p class="green" @click="showbox(account.mobile)">{{ account.mobile }}</p>
          </li>
          <li>
            <img
              src="data:image/png;base64,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"
              alt=""
            />
            <p class="center">微信</p>
            <p class="green" @click="wechatfun(account.wechat)">{{ account.wechat }}</p>
          </li>
        </ul>
      </div>
    </el-drawer>
    <el-drawer
      size="30%"
      direction="btt"
      :visible.sync="drawer2"
      :with-header="false"
      :show-close="false"
    >
      <div class="kefu">
        <p class="p1">使用问题和反馈意见</p>
        <p class="p1">购买{{website.web_title}}</p>
        <p class="button" @click="drawer2 = false">取消</p>
      </div>
    </el-drawer>
    <el-drawer
      size="64%"
      direction="btt"
      :visible.sync="drawer3"
      :with-header="false"
      :show-close="false"
    >
      <div class="LoginMain">
        <div class="head">
          登录{{website.web_title}}账号
          <div class="closeBtn" @click="drawer3 = false">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZHBCYMwFECTnDy6QR2hI7SbmIviFu0E0pMXISu4gSt0BEfoPZD0ByyUkmjycyr+Bx/0G/IeyBhBEMTR4b+LYRgqIcTsno0x167rFoYE7qrhrp5zPjVNI31nhGd3gancuBAXxPByBY+ltbZWSpVRAUVRTFD8XF9REV/yDzcp5ct3lvuWrlZrPUP5eV0tsb/DJ2/b9h46z0MfMBGp8s2A1AiMfDcgNgIrjwrYi8iRRweEImAeMD1WnhQQiGA58uSAjQiUHBXgiUDLsxnH8cQIgiD+nTd8h7YSUL389gAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
        </div>
        <div v-if="isWx == 2" class="form">
          <div class="inputBox">
            <el-input
              class="loginInput"
              max-length="11"
              placeholder="请输入手机号"
              v-model="form.mobile"
            ></el-input>
          </div>
          <div class="codeBox">
            <el-input
              class="loginInput"
              max-length="6"
              placeholder="请输入验证码"
              v-model="form.code"
            ></el-input>
            <el-button
              type="primary"
              :disabled="disabled"
              class="code"
              @click="smsSend"
              >{{ text }}</el-button
            >
          </div>
          <el-button
            type="primary"
            class="code"
            @click="loginfun"
            >登录</el-button
          >

          <div class="formTips">未注册的手机号验证后将自动创建账号</div>
        </div>
        <div class="bottom">
          <div class="wechatBtn" @click="wechatlogin()">
            <img
              src="data:image/png;base64,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"
              alt=""
            /><span>微信账号登录</span>
          </div>
          <div class="agreementTips">
            <div class="el-tooltip__trigger">
              <img
                v-if="!status"
                @click="status = true"
                class="agreeBtn icon"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAD4klEQVRYR81XT2gcdRT+3m9mShoX9BAxzQYMm92ZWbbQBiMGzMGAgmIOehAEA1ZQ0FNTWhERTwoKVownCwrmkIPgQcQcAgbiIWKlK4mHSebPZttCs5vSCBUkDd3ZefKbnYmbbf7s1uzqHGfe733fvG/mve8RmryWlpYeSiQSzwcBPw3gNIB+AD3R8U1mvkaEZQCLW1tb3w8NDd1uJjUdFmRZVlpVtfeYeYKI1MPio+fbAM0IgalMJmMddGZfAgsLC10nTiQ/AHhSAjOzT4SfmGkWCPKJRMLu7+//QyYvFouP+L4/wMyjAD0LQFZJXttEuLS+vv7u2NjY9l5E9iQQvfUPAMwIeEYI8WEmk1lrpgKrq6sDRMo7RDgDoIuZbebguWw2e63x/D0ECoXCY75fnSWiXoBtRVEm0un0b80AN8Y4jnMKoG+iF9lQVWW8MdcuAjXm4pcIfM73/Zdyudxf9wMen5FS9vX1fSelYeYNRRGj9ZXcIVALTC5JtgDPlUqlF/fTrVVCDSTscrk0FOfeIeC67mfMmJRlL5X+CWgVbL94y7ISqqpdqcmBi6apvy1jQwIrKysnFUWVDwHwiGEYvx8VcH2eYrF46u7dSl7eUxRhSilCAo7jfQnw68y4ZJr6W+0Aj3M6jvs1EP4d04ahv0ayw3V3P1CWv4umqQOpVOp6Owl4njdYrQa2xLhzZ+thchznVYCmAZ43DOOZdoLXVeFH2ayYaYLi8gN8wTCMTztBwHXds8yYkjLIClwBaJgII7qu/9oJArZdeJIoWGTmZXIc95acapqm9qZSqZudIOA4Tg9AtwDelARYghqGfuhkPEpyMe7/gkAoQRBUe7LZbDhe231ZltWrqlo5lkD2/9PMYtQ00z+3G1zmd92rTzBXLjNzXkoQdiY5B0xT/7wTBByncB4ILgL8FXme90oQ8Mx/0YgAPhO24uPHu+V3sDMg2lkF6TmEUK5Ku6aqSm80jHYPiHYScF33C2a8KctvGMYbIYH6AUGE4XaN48iiXZaYQtCwdMw7zce23U+IcEEayGrVf/zfWrHGKtY7LiJM6bp+TsZ03JI1Oq5d7TeSYjE2pUfhC2tWTP02NqXHjmkj9Z7jQFsu5SDCy/f7TbRsy2PdisXio5WKP1dzyOF2M62q6sfNuqV71zm2hRDjey02B65myWTyo9ovg66I3Ly07ES0WKlUrudyuQ15P593ehIJxRAiGGbGODM/Fa9zAE+Vy+X3W1rN6r9gz/NyQRBMAjRRR+TAVtHKOte0B1hbW3vQ9/0XAIwyh+v5ABGF6zkzbxLRDQDLzDSvaWJ2cHDwz2Ya2t+r/w4xxTgUnAAAAABJRU5ErkJggg=="
              />
              <img
                v-else
                @click="status = false"
                class="agreeBtn icon"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALLSURBVHgBvZcxb9NAFMffu4vT0KrIHeiG5ExBTM7AQobQT0C6MUZMhKVi7BQyoEoshIV2QcrISD5Bw9AuIOGRTlhigyFR06TExj7uOXHqJnZiNXb/Sxz5/H7v7t67dw8hpvS6UJ2NfgWAl1H+BQRNCFDpHSL0QIApAAxkrMP6ubbRwF4cu7gUfHCpOUzsIRNVHxhTLe6whrF/x4SbOEAzdjcGrwXgHqwiIZp8aDeMxlYvtgM0a5eLYwFCgwSEgCZzcCdsNdgc/O2FniScRLbI5sM3FzrMOReEJzzzedj8SkwdGO/55fe04NecGIyKfkxMt2AccOnCScRw1pX6lUMwSTXu/oRblEzRPG2FtwISXodbFp0t9Iv6u67q2NkuJKxH9zmcj1w4+y2ihvT4wMpnHFupQMKqlRSoPVa85+ef/sK3X27YMNXeVJ7KLcAyJKggnNQfRa4AMBefMFlIdEgJ/uHEWrQFlBE6kwVGg5TgR6f/Fn4jzwSNsiCywlEgFbaXFswbwSdSM1FvCtsMPj5bGxs8teHoxE4a7olWILRM3l27en4pAS9KSuJwYlMQmmFvvsrUOZQGo5xIAE5BaGZkEBoA4ZlwODFYK2WnTpAoKlaFj+2gIWPA+SJP5mrUoCgnVoWTXCE6jCvOZ4iIg6ATwe1IAk5ShnabGa9kXUZsLRs868SqcKkW3Qm8JH9w0NUUno1Vjgv3GGzmIOp8jy3bsfI/9rfG5Zge5Co043x49sddGQ4Cmx4TAjcinhk1qLmAtCUZ/aFkTTR1gGLBdq2dVJ2QtolhBnqEa9dyWhYHxW4qTkibDlq7/tL7Cq00XlCy7DH1f5AQnGY+CyexsPE0kGetYtzAXAzHZn9oFcPgpKW1dpKidGmtQmwJ2S2zlu2O3keBYzvgS6t31fUcr3DOy/KOo6PXQ6DqA2UT67XnnInOed9umxHN6Kz+A8GgbzpxRXwcAAAAAElFTkSuQmCC"
              />
              <span>阅读并同意</span>
            </div>
            <span class="blueText" @click="jump(1)">《用户服务协议》</span>及<span class="blueText"  @click="jump(2)">《隐私政策》</span>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      size="46%"
      direction="btt"
      :visible.sync="drawer4"
      :with-header="false"
      :show-close="false"
    >
      <div class="LoginMain" v-if="phonestatus==0">
        <div class="head">
          绑定手机号
          <div class="closeBtn">
            <img
              @click="cancelBindMobile"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZHBCYMwFECTnDy6QR2hI7SbmIviFu0E0pMXISu4gSt0BEfoPZD0ByyUkmjycyr+Bx/0G/IeyBhBEMTR4b+LYRgqIcTsno0x167rFoYE7qrhrp5zPjVNI31nhGd3gancuBAXxPByBY+ltbZWSpVRAUVRTFD8XF9REV/yDzcp5ct3lvuWrlZrPUP5eV0tsb/DJ2/b9h46z0MfMBGp8s2A1AiMfDcgNgIrjwrYi8iRRweEImAeMD1WnhQQiGA58uSAjQiUHBXgiUDLsxnH8cQIgiD+nTd8h7YSUL389gAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
        </div>
        <div class="form">
          <div class="inputBox">
            <el-input
              class="loginInput"
              max-length="11"
              placeholder="请输入手机号"
              v-model="bindform.mobile"
            ></el-input>
          </div>
          <div class="codeBox">
            <el-input
              class="loginInput"
              max-length="6"
              placeholder="请输入验证码"
              v-model="bindform.code"
            ></el-input>
            <el-button
              type="primary"
              :disabled="disabled"
              class="code"
              @click="smsSend"
              >{{ text }}</el-button
            >
          </div>
          <el-button
            type="primary"
            class="code"
            @click="userBindMobileForCenter(bindform)"
            >绑定</el-button
          >
        </div>
      </div>
      <div class="LoginMain" v-if="phonestatus==1">
        <div class="head">
          验证手机号
          <div class="closeBtn">
            <img
              @click="drawer4 = false;phonestatus = 0;"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZHBCYMwFECTnDy6QR2hI7SbmIviFu0E0pMXISu4gSt0BEfoPZD0ByyUkmjycyr+Bx/0G/IeyBhBEMTR4b+LYRgqIcTsno0x167rFoYE7qrhrp5zPjVNI31nhGd3gancuBAXxPByBY+ltbZWSpVRAUVRTFD8XF9REV/yDzcp5ct3lvuWrlZrPUP5eV0tsb/DJ2/b9h46z0MfMBGp8s2A1AiMfDcgNgIrjwrYi8iRRweEImAeMD1WnhQQiGA58uSAjQiUHBXgiUDLsxnH8cQIgiD+nTd8h7YSUL389gAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
        </div>
        <div class="form">
          <div class="inputBox">
            <el-input
              class="loginInput"
              max-length="11"
              placeholder="请输入手机号"
              v-model="checkform.mobile"
            ></el-input>
          </div>
          <div class="codeBox">
            <el-input
              class="loginInput"
              max-length="6"
              placeholder="请输入验证码"
              v-model="checkform.code"
            ></el-input>
            <el-button
              type="primary"
              :disabled="disabled"
              class="code"
              @click="smsSendV2(checkform.mobile)"
              >{{ text }}</el-button
            >
          </div>
          <el-button
            type="primary"
            :disabled="disabled"
            class="code"
            @click="userBindMobileForCenter(checkform)"
            >验证</el-button
          >
        </div>
      </div>
      <div class="LoginMain" v-if="phonestatus==2">
        <div class="head">
          更换手机号
          <div class="closeBtn">
            <img
             @click="drawer4 = false;phonestatus = 0"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZHBCYMwFECTnDy6QR2hI7SbmIviFu0E0pMXISu4gSt0BEfoPZD0ByyUkmjycyr+Bx/0G/IeyBhBEMTR4b+LYRgqIcTsno0x167rFoYE7qrhrp5zPjVNI31nhGd3gancuBAXxPByBY+ltbZWSpVRAUVRTFD8XF9REV/yDzcp5ct3lvuWrlZrPUP5eV0tsb/DJ2/b9h46z0MfMBGp8s2A1AiMfDcgNgIrjwrYi8iRRweEImAeMD1WnhQQiGA58uSAjQiUHBXgiUDLsxnH8cQIgiD+nTd8h7YSUL389gAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
        </div>
        <div class="form">
          <div class="inputBox">
            <el-input
              class="loginInput"
              max-length="11"
              placeholder="请输入手机号"
              v-model="changeform.mobile"
            ></el-input>
          </div>
          <div class="codeBox">
            <el-input
              class="loginInput"
              max-length="6"
              placeholder="请输入验证码"
              v-model="changeform.code"
            ></el-input>
            <el-button
              type="primary"
              :disabled="disabled"
              class="code"
              @click="smsSendV2(changeform.mobile)"
              >{{ text }}</el-button
            >
          </div>
          <el-button
            type="primary"
            class="code"
            @click="userBindMobileForCenter(changeform)"
            >更换</el-button
          >
        </div>
      </div>
    </el-drawer>

    <div class="modal-wrap" v-if="wechatstatus" @click="closelogin()">
      <div  class="flex-center">
        <div  class="trans-box" style="width: 80%">
          <div  class="main">
            <div  class="title">
              打开微信扫码，绑定微信账号
            </div>
            <div  class="qrcode">
              <img
                :src="wechat.qrcode"
                alt="qrcode"
                class="qrcode-image"
              />
            </div>
            <div  class="text_content" style="color:#fff">
              <div  class="text">
                <span >1. </span
                >长按二维码图片保存后，在微信中打开图片
              </div>
              <div  class="text">
                <span >2. </span
                >长按图片，选择“识别图中的二维码”
              </div>
              <div  class="text">
                <span >3. </span
                >关注公众号，回到{{website.web_title}}，绑定成功
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var _this,time;
import {
  getAccountSetting,
  userBindMobileForCenter,
  smsSendV2,
  userUnbindWechat,
} from "@/api/user";
import {
  wechatCode,
  userScanLogin,
  smsSend,
  userMobileLogin,
  userMpCodeLogin,
} from "@/api/login";
import { getIndexData } from "@/api/index";
import copyright from "@/components/copyright";
import { validatePhoneNumber } from "@/utils/commom";
export default {
  components: {
    copyright,
  },
  data() {
    return {
      wechatstatus:false,
      phonestatus:0,
      bindform: {
        mobile: "",
        code: "",
        type:"bind"
      },
      checkform: {
        mobile: "",
        code: "",
        type:"check"
      },
      changeform: {
        mobile: "",
        code: "",
        type:"change "
      },
      status: true,
      form: {
        mobile: "",
        code: "",
      },
      second: 60,
      text: "获取验证码",
      disabled: false,
      login: false,
      drawer2: false,
      drawer1: false,
      drawer3: false,
      drawer4: false,
      swiperIndex: -1,
      swiperOption: {
        slidesPerView: 4.5,
        spaceBetween: 8,
        on: {
          click: (e) => {
            this.swiperClick(e);
          },
        },
      },
      swiperdata: [],
      bg: require("@/assets/mobile/vip_card_bg-ddc6fc5c.png"),
      drawer: false,
      userdata: this.$store.userInfo,
      website: this.$store.website,
      account: {},
      fun: [
        {
          name: "升级会员",
          icon: require("@/assets/mobile/upgrade-667b996b.png"),
          type: 1,
          router: "/member",
        },
        {
          name: "创作历史",
          icon: require("@/assets/mobile/history-00c5dcee.png"),
          type: 1,
          router: "/history",
        },
        {
          name: "反馈建议",
          icon: require("@/assets/mobile/feedback-e997ad6f.png"),
          type: 1,
          router:"/feedback"
        },
        {
          name: "推荐有奖",
          icon: require("@/assets/mobile/invite-1861059a.png"),
          type: 1,
          router: "/invite",
        },
      ],
      list: [
        [
          {
            name: "创作历史",
            icon: require("@/assets/mobile/img1.png"),
            router: "/history",
            type: 1,
          },
          {
            name: "我的订单",
            icon: require("@/assets/mobile/img2.png"),
            router: "/order",
            type: 1,
          },
          {
            name: "分钟数记录",
            icon: require("@/assets/mobile/img3.png"),
            router: "/point",
            type: 1,
          },
          {
            name: "账号绑定",
            icon: require("@/assets/mobile/img4.png"),
            type: 2,
          },
        ],
        [
          {
            name: "推荐有奖",
            icon: require("@/assets/mobile/img5.png"),
            type: 1,
            router: "/invite",
          },
          {
            name: "反馈建议",
            icon: require("@/assets/mobile/img6.png"),
            type: 1,
            router:"/feedback"
          },
          {
            name: "联系客服",
            icon: require("@/assets/mobile/img7.png"),
            type: 3,
          },
          {
            name: "关于我们",
            icon: require("@/assets/mobile/img8.png"),
            type: 1,
            router: "/about",
          },
        ],
      ],
      params: {
        cid: 0,
        keyword: "",
      },
      createlist: [],
      wechat:[],
	  isWx:2,
    };
  },
  mounted() {
	  let code = this.$route.query.code; //code只能使用一次
	  var ua = navigator.userAgent.toLowerCase();
	  var isWeixin = ua.indexOf('micromessenger') != -1;
  　　if (isWeixin) {
	 　　 this.isWx = 1;
  　　}else{
	 　　 this.isWx = 2;
  　　}
    _this = this;
    if (localStorage.getItem("gpt-token")) {
      this.login = true;
      // userInfo().then(res=>{
      //   this.userdata = res.data
      // })
    } else {
      this.login = false;
      
      if (code) {
		  this.drawer3 = false;
		  let inviteCode = sessionStorage.getItem('inviteCode');
        userMpCodeLogin({ code: code,invite:inviteCode }).then((res) => {
          localStorage.setItem("gpt-token", res.data.token);
          localStorage.setItem("loginStatus", 1);
		  let url = window.location.href;
		  if(res.data.mobile == '') {
			  this.drawer4 = true;
		  }else {
			  location.reload();
		  }
        });
      }
    }
    if (!code && localStorage.getItem("loginStatus") == 0 && window.innerWidth < 1000) {
      this.drawer3 = true;
      localStorage.setItem("loginStatus", 1);
    }
    this.getIndexData();
  },
  methods: {
	  cancelBindMobile() {
		this.drawer4 = false;
		this.phonestatus = 0;
		window.location.reload();  
	  },
    userBindMobileForCenter(data) {
      userBindMobileForCenter(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: "success",
          });
          if(data.type=="check"){
            this.phonestatus = 2
          }else{
            location.reload();
          }
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
        _this.modalstatus = false;
      });
    },
    smsSendV2(mobile) {
      if (!validatePhoneNumber(mobile)) {
        _this.$message.error("手机号码格式错误");
        return false;
      }
      smsSendV2({ mobile:mobile }).then((res) => {
        _this.disabled = true;
        let time = setInterval(() => {
          _this.text = _this.second + "s";
          _this.second--;
          if (_this.second == 0) {
            _this.second = 60;
            _this.disabled = false;
			_this.text = '获取验证码';
            clearInterval(time);
          }
        }, 1000);
      });
    },
    wechatfun(data){
        if(data=="未绑定"){
          this.wechatCode()
        }else{
          this.$confirm("是否确定解绑微信", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          }).then(() => {
              userUnbindWechat().then(res=>{
                  location.reload();
              })
          })
        }
    },
    wechatCode() {
      wechatCode().then((res) => {
        _this.wechat = res.data;
        this.wechatstatus = true;
        _this.userScanLogin();
      });
    },
    //扫码登录
    userScanLogin() {
      time = setInterval(function(){
        userScanLogin({ ticket: _this.wechat.ticket }).then((res) => {
          if (res.code == 0) {
            clearInterval(time);
            location.reload();
          }
        });
      }, 1000);
    },
    closelogin(){
      clearInterval(time);
      this.wechatstatus = false;
    },
    wechatlogin() {
      window.location.href =  "https://admins.kv1.cn/v1/index/code?url=" + encodeURIComponent(window.location.href);
      // window.location.href =  "https://jkquaiadmins.kangqiao.vip/v1/index/code?url=" + encodeURIComponent(window.location.href);
    },
    showbox() {
      this.drawer4 = true;
      if(this.account.mobile == "未绑定"){
        this.phonestatus = 0
      }else{
        this.phonestatus = 1
      }
    },
    getAccountSetting() {
      getAccountSetting().then((res) => {
        this.account = res.data;
      });
    },
    getIndexData() {
      var that = this;
      getIndexData(this.params).then((response) => {
        that.swiperdata = response.data.category;
        that.createlist = response.data.template;
        this.$forceUpdate();
      });
    },
    // userBindMobileForCenter() {
    //   if (this.bindform.code == "") {
    //     _this.$message.error("验证码不能为空");
    //     return false;
    //   }
    //   if (!validatePhoneNumber(_this.bindform.mobile)) {
    //     _this.$message.error("手机号码格式错误");
    //     return false;
    //   }
    //   userBindMobileForCenter(_this.bindform).then((res) => {
    //     if (res.code == 0) {
    //       location.reload();
    //     } else {
    //       _this.$message.error(res.message);
    //     }
    //   });
    // },
    loginfun() {
      if (!this.status) {
        _this.$message.error("请先勾选同意政策协议");
        return false;
      }
      if (this.form.code == "") {
        _this.$message.error("验证码不能为空");
        return false;
      }
      if (!validatePhoneNumber(_this.form.mobile)) {
        _this.$message.error("手机号码格式错误");
        return false;
      }
	  _this.form.invite = sessionStorage.getItem('inviteCode');
      userMobileLogin(_this.form).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("gpt-token", res.data.token);
          location.reload();
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    loginout() {
      localStorage.removeItem("gpt-token");
      location.reload();
    },
    smsSend() {
      if (!validatePhoneNumber(_this.bindform.mobile)) {
        _this.$message.error("手机号码格式错误");
        return false;
      }
      smsSend({ mobile: _this.bindform.mobile }).then((res) => {
        _this.disabled = true;
        let time = setInterval(() => {
          _this.text = _this.second + "s";
          _this.second--;
          if (_this.second == 0) {
            _this.second = 60;
            _this.disabled = false;
			_this.text = '获取验证码';
            clearInterval(time);
          }
        }, 1000);
      });
    },
    swiperClick(e) {
      this.swiperIndex = e.target.getAttribute("data-index");
      this.params.cid = e.target.getAttribute("data-id");
      this.getIndexData();
    },
    jumppage(type, id) {
      if (type == 2) {
        this.$router.push({ path: "/copywriting/" + id });
      } else if (id == 1) {
        this.$router.push({ path: "/microvideo" });
      } else if (id == 2) {
        this.$router.push({ path: "/customized" });
      } else if (id == 3) {
        // this.$router.push({ path: "/face" });
		this.$message({
		  message:'暂未开放'
		})
      }else if (id == 4) {
        this.$router.push({ path: "/clone" });
      }
    },
    jump(index) {
      switch (index) {
        case 1:
          window.open(this.$store.website.serve_url)
          break;
        case 2:
          window.open(this.$store.website.privacy_url)
          break;
      }
    },
    jumprouter(router, type) {
      if (type == 1) {
        this.$router.push({ path: router });
      }
      if (type == 2) {
        this.drawer = false;
        this.drawer1 = true;
        this.getAccountSetting();
      }
      if (type == 3) {
        // this.drawer = false;
        // this.drawer2 = true;
		window.open(this.$store.website.contact_customer_service)
      }
    },
  },
};
</script>

<style lang="less">
.mobileindex {
  .modal-wrap {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2018;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .trans-box{
      margin:0 auto;
    }
    .title{
      color: #fff;
      text-align: center;
      margin-bottom: 20px;
    }
    .text_content{
      .text{
        margin:10px 0
      }
    }
    img{
      display: block;
      margin:0 auto;
      width: 80%;
    }
  }
  background-color: #fff;
  .LoginMain {
    padding: 24px 32px;
    .head {
      font-weight: 700;
      font-size: 22px;
      color: #333;
      position: relative;
      display: flex;
      justify-content: space-between;
      .closeBtn {
        position: absolute;
        right: 0px;
        top: 4px;
        width: 24px;
        height: 24px;
        font-size: 0;
        padding: 6px;
        border-radius: 50%;
        background: rgba(217, 217, 217, 0.3);
        cursor: pointer;
        img {
          width: 12px;
        }
      }
    }
    .form {
      .codeBox {
        display: flex;
        gap: 12px;
        .el-button {
          width: 120px;
        }
      }
      .loginInput {
        width: 100%;
        height: 48px;
        font-size: 14px;
        background: #f4f4f4;
        border-radius: 8px;
        border: none;
        padding: 0 12px;
        display: flex;
        align-items: center;
        margin-top: 20px;
        .el-input__inner {
          width: 100%;
          border: none;
          background-color: transparent;
          padding: 0;
        }
      }
      .code {
        width: 100%;
        margin-top: 20px;
      }
    }
    .formTips {
      color: #888889;
      font-size: 12px;
      text-align: center;
      margin-top: 8px;
    }
    .bottom {
      border-top: 0.5px solid #eeeeee;
      margin: 16px 12px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .wechatBtn {
        height: 40px;
        background: #f9f9ff;
        border-radius: 20px;
        width: 148px;
        text-align: center;
        margin-top: 16px;
        margin-bottom: 18px;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333;
        img {
          width: 28px;
          margin-right: 8px;
        }
      }
      .agreementTips {
        font-size: 12px;
        color: #666;
        width: 100%;
        text-align: center;
        display: flex;
        .agreeBtn {
          vertical-align: top;
          cursor: pointer;
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }
        .blueText {
          cursor: pointer;
          color: #2d8af5;
        }
      }
    }
  }
  .to-login-box {
    padding: 16px 0 0;
    text-align: center;
    .title {
      color: #333;
      font-weight: 700;
      font-size: 26px;
      line-height: 36px;
    }
    .sub-title {
      font-size: 12px;
      color: #999;
      line-height: 18px;
      margin-top: 4px;
    }
    .loginBtn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 12px auto 0;
      width: 92px;
      cursor: pointer;
      height: 36px;
      color: #fff;
      background: linear-gradient(
          106.92deg,
          #10c5fe 14.83%,
          #1093fe 31.52%,
          #4f4fe7 65.11%,
          #b60cb9 91.29%,
          #e0caf5 102.83%
        ),
        #2d8af5;
      box-shadow: 0 2px 8px rgba(52, 70, 237, 0.1);
      border-radius: 18px;
    }
  }
  .kefu {
    padding: 20px 32px 0;
    .p1 {
      display: block;
      color: #333;
      font-size: 16px;
      margin-bottom: 32px;
      text-align: center;
      width: 100%;
    }
    .button {
      width: 100%;
      height: 48px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0 12px;
      line-height: 1;
      color: #000;
      background: #f4f5f7;
      border-radius: 8px;
      text-align: center;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .accountbox {
    padding: 20px 32px 0;
    .title {
      font-weight: 700;
      font-size: 20px;
      color: #333;
      display: flex;
      justify-content: space-between;
      p:nth-child(2) {
        margin-top: 3px;
        width: 24px;
        height: 24px;
        font-size: 0;
        border-radius: 50%;
        background: rgba(217, 217, 217, 0.3);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 16px;
        }
      }
    }
    ul {
      li {
        cursor: pointer;
        height: 64px;
        background: #f7f7f7;
        border-radius: 8px;
        color: #333;
        font-size: 14px;
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px;
        .center {
          flex: 1 0 10%;
          text-align: left;
        }
        img {
          width: 28px;
          vertical-align: middle;
          margin-right: 8px;
        }
        .green {
          color: #2d8af5;
        }
        .gray {
          color: #999;
        }
      }
    }
  }
  .mobiletop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    height: 72px;
    .logo {
      width: 80px;
    }
    .avatar {
      width: 32px;
    }
    .el-drawer__body {
      background: #f4f5f7;
      padding: 40px 20px 20px;
      .usermsg {
        display: flex;
        justify-content: space-between;
        div:nth-child(1) {
          display: flex;
          align-items: center;
          img {
            width: 28px;
            overflow: hidden;
            border-radius: 12px;
            margin-right: 8px;
          }
          p {
            span:nth-child(1) {
              font-size: 14px;
            }
            span {
              display: block;
              font-size: 12px;
              color: #333;
            }
          }
        }
        div:nth-child(2) {
          p {
            position: relative;
            background: #e6ebf2;
            height: 16px;
            line-height: 16px;
            border-radius: 8px;
            color: #727d88;
            padding: 0 4px 0 16px;
            font-size: 10px;
            min-width: 40px;
            img {
              width: 16px;
              position: absolute;
              left: 0;
            }
          }
        }
      }
      .member {
        width: 100%;
        height: 78px;
        border-radius: 8px;
        margin-bottom: 20px;
        position: relative;
        margin-top: 20px;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 22px;
        div:nth-child(1) {
          p:nth-child(1) {
            font-size: 14px;
            font-weight: 700;
            color: #fff5db;
            img {
              width: 26px;
            }
          }
          p:nth-child(2) {
            color: #dfe5e6;
            font-size: 12px;
          }
        }
        div:nth-child(2) {
          font-size: 12px;
          color: #3a3329;
          padding: 3px 0;
          height: 26px;
          width: 70px;
          background: linear-gradient(90deg, #fff5db -0.14%, #f4e3b8 9309.86%);
          border-radius: 4px;
          text-align: center;
        }
      }

      .card {
        width: 100%;
        background: #fff;
        border-radius: 4px;
        padding: 6px 10px;
        margin-bottom: 16px;
        img {
          width: 20px;
          vertical-align: middle;
          margin-right: 8px;
        }
        span {
          font-size: 14px;
          color: #333;
        }
        ul {
          li {
            height: 40px;
            line-height: 40px;
            padding: 0 12px;
            color: #020713;
            border-bottom: 1px solid #f9f7f7;
          }
          li:last-child {
            border-bottom: none;
          }
        }
      }

      .el-button {
        width: 100%;
        color: red;
      }
    }
  }
  .mobilecenter {
    padding-bottom: 12px;
    ul {
      display: flex;
      justify-content: center;
      gap: 24px;
      img {
        width: 48px;
      }
      p {
        font-size: 12px;
        font-weight: 700;
      }
    }
    .swiper {
      margin-top: 40px;
      position: sticky;
      top: 0;
      width: 100%;
      background-color: #fff;
      .swiper-slide {
        color: #666;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .swiperOn {
        color: #333;
        font-size: 16px;
        font-weight: 700;
        position: relative;
      }
    }
  }

  .mobilefooter {
    width: 100%;
    background-color: #fbfcfd;
    padding-top: 20px;
    ul {
      background-color: #fff;
      margin: 0 20px 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
      border-radius: 12px;
      padding: 16px 24px;
      li {
        display: flex;
        align-items: center;
        padding-bottom: 16px;
        margin-bottom: 16px;
        border-bottom: 1px solid #f4f4f4;
        img {
          width: 20px;
        }
        .left {
          flex: 1 0 10%;
          div:nth-child(1) {
            display: flex;
            align-items: center;
            p {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 10px;
              padding: 6px;
              width: 32px;
              height: 32px;
              background: #fff;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
              border-radius: 8px;
            }
            span {
              color: rgba(0, 0, 0, 0.8);
              font-size: 18px;
              font-weight: 700;
            }
          }
          div:nth-child(2) {
            color: #666;
            font-size: 12px;
            line-height: 17px;
            margin-top: 5px;
          }
        }
      }
    }
  }
  .no-data-box{
    text-align: center;
    padding: 200px 0;
    .clear-title{
      color: #2d8af5;
    }
  }
}
</style>